import a, { useEffect as o } from "react";
import { I18N as n } from "../../../js/i18n/index.js";
import { initReactI18next as i, I18nextProvider as c } from "react-i18next";
const t = n.createI18nInstance([
  i
]);
function m({ children: r, lng: e }) {
  return o(() => {
    e !== void 0 && t.changeLanguage(e);
  }, [e]), /* @__PURE__ */ a.createElement(c, { i18n: t }, r);
}
function I() {
  return t.resolvedLanguage ?? n.fallbackLng;
}
export {
  m as I18NProvider,
  I as getCurrentLanguage,
  t as i18nInstance
};
//# sourceMappingURL=i18n.js.map
